let mapGetters = Vuex.mapGetters;
let mapSetters = Vuex.mapSetters;

const vuexStore = new Vuex.Store({

    state: {
        trunks: [],

        currentMainTrunk: null,

        currentDid: null,

        currentEndPoint: null,

        currentInterval: 'quarterly',

        currentIntervalStatistic: [],

        currentGraph: {},

        currentGraphReady: false,

        currentDateTimePick : moment().format('YYYY-MM-DD HH:mm'),

        dids: [],

        endPoints: [],

        customerName : null,

        statistics: []
    },

    mutations: {

        /**
         * Set the current main trunk which has statistic stored.
         *
         * @param state
         * @param trunkNumber
         */
        setMainTrunk(state, trunkNumber) {
            state.currentMainTrunk = trunkNumber;
        },

        setCurrentDid(state, did) {
            state.currentDid = did;

        },

        setCurrentEndPoint(state, endPoint) {
            state.currentEndPoint = endPoint;

        },

        setCurrentInterval(state, interval) {
            state.currentInterval = interval;
        },

        setCurrentStatisticEntries(state, data) {
            state.currentIntervalStatistic = data;
        },

        setCurrentGraph(state, data) {
            state.currentIntervalStatistic = data;
        },

        setCurrentGraphReady(state, data) {
            state.currentGraphReady = data;
        },

        setCurrentDateTimePick(state, data) {
            state.currentDateTimePick = data;
        },


        /**
         * Set state of customer trunks
         *
         * @param state
         * @param data
         */
        setCustomerTrunks(state, data) {
            state.trunks = data;
        },

        setEndPoints(state, endPoints) {
            state.endPoints = endPoints;

        },

        setDids(state, dids) {
            state.dids = dids;
        },

        setCustomerName(state, customerName) {
            state.customerName = customerName;
        },
    },

    actions: {

        fetchCustomerName(context){
            return httpClient.get('/statistic/customer').then(data => {
                if (data.result === 'ok') {
                    if(data.customerName.hasOwnProperty('CustomerName')){
                        let customerName = data.customerName.CustomerName;
                        context.commit('setCustomerName', customerName);
                    }
                }
            }).catch((error) => {
                console.log(error);
            });
        },

        /**
         * Get all trunks associated with the logged-in user
         *
         * @param context
         */
        fetchCustomerTrunks(context) {
            return httpClient.get('/statistic/trunks').then(data => {
                if (data.result === 'ok' && data.trunks.length !== 0) {
                    let trunkSet = [];
                    Object.keys(data.trunks.Trunks).forEach((key) => {
                        trunkSet.push(data.trunks.Trunks[key].TrunkNumber);
                    });
                    context.commit('setCustomerTrunks', trunkSet);
                }
            }).catch((error) => {
                console.log(error);

            });
        },

        updateChosenMainTrunk({commit, dispatch, state}, mainTrunk) {
            commit('setMainTrunk', mainTrunk);
            return dispatch('fetchReducedStatistic');
        },
        updateChosenDid({commit, dispatch, state}, did) {
            commit('setCurrentDid', did);
            dispatch('fetchReducedStatistic');
        },
        updateChosenEndPoint({commit, dispatch, state}, endPoint) {
            commit('setCurrentEndPoint', endPoint);
            dispatch('fetchReducedStatistic');
        },
        updateChosenInterval({commit, dispatch, state}, interval) {
            commit('setCurrentInterval', interval);
            dispatch('fetchReducedStatistic');
        },
        updateDateTimePick({commit, dispatch, state}, time) {
            commit('setCurrentDateTimePick', time);
            dispatch('fetchReducedStatistic');
        },

        fetchReducedStatistic(context) {

            let period = labelsBuilder.getIntervalStartAndEndTime(
                context.state.currentDateTimePick,
                context.state.currentInterval
            );

            let data = {
                'groupedInterval': context.state.currentInterval,
                'trunkId': context.state.currentMainTrunk,
                'startTime': period.start,
                'endTime': period.end,
                'phoneNumber': context.state.currentEndPoint,
                'directInwardDialingNumber': context.state.currentDid,
            };

            return httpClient
                .get(`/statistic/reduced`, data)
                .then(response => {

                    let dids = [];
                    let endPoints = [];
                    let storedStatistic = [];


                    if (!(response.statistic.length === 0)) {

                        let endPointMappings = [];
                        let didMappings = [];
                        let statisticEntries = [];

                        if (response.statistic.hasOwnProperty('ReducedEntries')) {
                            statisticEntries = response.statistic.ReducedEntries;
                        }

                        if (response.statistic.hasOwnProperty('EndPointMap')) {
                            if (response.statistic.EndPointMap.hasOwnProperty('Mappings')) {
                                endPointMappings = response.statistic.EndPointMap.Mappings;
                            }
                        }

                        if (response.statistic.hasOwnProperty('DidMap')) {
                            if (response.statistic.DidMap.hasOwnProperty('Mappings')) {
                                didMappings = response.statistic.DidMap.Mappings;
                            }
                        }

                        Object.values(didMappings).forEach(value => {
                            dids.push(parseInt(value['Did']));
                        });

                        Object.values(endPointMappings).forEach(value => {
                            endPoints.push(parseInt(value['EndPoint']));
                        });

                        Object.keys(statisticEntries).forEach(key => {
                            storedStatistic.push(statisticEntries[key]);
                        });



                    }
                    context.commit('setCurrentStatisticEntries', storedStatistic);
                    context.commit('setEndPoints', endPoints);
                    context.commit('setDids', dids);
                })
        }

    },

    getters: {
        getPBXes: state => state.pbxes,

        getCustomerTrunks: state => state.trunks,

        getCustomerName: state => state.customerName,

        getActualMainTrunk: state => state.currentMainTrunk,

        getPhoneNumbers: state => state.endPoints,

        getCurrentInterval: state => state.currentInterval,

        getCurrentIntervalStatistic: state => state.currentIntervalStatistic,

        getCurrentDid: state => state.currentDid,

        getCurrentEndPoint: state => state.currentEndPoint,

        getCurrentDateTimePick: state => state.currentDateTimePick,

        getDids: state => state.dids,
    },

});
